export default "__VITE_ASSET__DL8YS5cP__"